import { CreatedEvent, EcommerceFlightItem, PointsValue } from '../../../types';

export type FlightOptionInteractionsEventProps = {
  item: EcommerceFlightItem;
  paymentType: PointsValue;
  availablePackageCount?: number;
  priceChange: string;
  pointsValue: number;
  travelDetails: {
    origin?: string | null;
    destination?: string | null;
    duration?: number;
    departureDate?: string;
    returnDate?: string;
  };
  action?: 'select' | 'add';
};

export const createFlightOptionInteractionsEvent = ({
  item,
  paymentType,
  availablePackageCount,
  priceChange,
  pointsValue,
  travelDetails,
  action = 'select',
}: FlightOptionInteractionsEventProps): CreatedEvent => {
  const isSelectAction = action === 'select';

  return {
    eventInfo: {
      event: isSelectAction ? 'select_item' : 'add_to_cart',
      event_data: {
        action,
        available_package_count: availablePackageCount,
        component_type: isSelectAction ? 'item' : 'cart',
        destination: travelDetails.destination,
        duration: travelDetails.duration,
        end_date: travelDetails.returnDate,
        origin: travelDetails.origin,
        page_type: 'flight options',
        search_payment_toggle: paymentType,
        search_type: 'list',
        start_date: travelDetails.departureDate,

        travellers_adult: item.travellers_adults || 2,
        travellers_children: item.travellers_children || 0,
        travellers_infant: item.travellers_infants || 0,
        international_or_domestic: item.international_or_domestic,
        item_category: item.item_category,
        travel_class: item.item_variant,
        flight_number: item.item_id,
        stops: item.stops,
        flight_type: item.flight_type,
        quantity: item.quantity,
        price: item.price,

        price_change: priceChange,
        points_value: pointsValue,
      },
      ecommerce: {
        currency: 'AUD',
        value: item.price,
        payment_type: paymentType,
        items: [item],
      },
    },
    eventOptions: {
      debugMessage: isSelectAction
        ? 'GA4 Data Layer Event (Flight Options Select Item)'
        : 'GA4 Data Layer Event (Flight Options Add to Cart)',
    },
  };
};
